import { render } from "./vTextArea.vue?vue&type=template&id=8d0ea562&scoped=true"
import script from "./vTextArea.vue?vue&type=script&lang=js"
export * from "./vTextArea.vue?vue&type=script&lang=js"

import "./vInput.less?vue&type=style&index=0&id=8d0ea562&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0ea562"]])

export default __exports__